import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { ContentHeader } from "~/components/AssetModalV2/Content/Header/ContentHeader";
import { usePublicPermissions } from "~/components/PublicPermissionsProvider";
import { usePublicAssetCustomFieldsData } from "~/hooks/usePublicAssetCustomFieldsData";
import { canSeeAssetCustomFields } from "~/utils/permissions/assetPermissions";
export const PublicContentHeader = /*#__PURE__*/ memo(()=>{
    const { permissions } = usePublicPermissions();
    const canViewCustomFields = canSeeAssetCustomFields(permissions);
    const { data: customFields } = usePublicAssetCustomFieldsData();
    return /*#__PURE__*/ _jsx(ContentHeader, {
        customFields: canViewCustomFields ? customFields === null || customFields === void 0 ? void 0 : customFields.data : undefined
    });
});
PublicContentHeader.displayName = "PublicContentHeader";
